import { Icon } from '@design/components/icon/Icon';
import { WithNAFallback } from '@design/components/table';
import { Tooltip, TooltipTrigger } from '@design/components/tooltip/Tooltip';
import { formatPercentage, getPriceStatus } from '@helpers';
import { priceChangeColors } from '@terminal/utils/common/utils';
import { useTranslation } from 'react-i18next';

import styles from './PercentageCell.module.scss';

export interface PercentageCellProps {
  value?: number;
  suffix?: '%' | 'bps';
  showStarIcon?: boolean;
}

export const PercentageCell = ({
  value,
  suffix = '%',
  showStarIcon,
}: PercentageCellProps) => {
  const { t } = useTranslation('scenario');

  return (
    <div className={styles.root}>
      {showStarIcon && (
        <Tooltip
          label={
            <span className={styles.nonNumericText}>
              {t('scenario:table.tooltips.starIcon')}
            </span>
          }
          trigger={TooltipTrigger.Hover}
        >
          <span>
            <Icon
              iconName="StarFill"
              fillColor="var(--icon-primary)"
              size={12}
            />
          </span>
        </Tooltip>
      )}

      <span
        className={styles.coloredValue}
        style={{ color: priceChangeColors[getPriceStatus(value)] }}
      >
        <WithNAFallback
          value={
            typeof value === 'number' &&
            formatPercentage(value, { suffix, addPlus: suffix === '%' })
          }
        />
      </span>
    </div>
  );
};
